export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/tile_bachelorette-31b45620f7c9e10933e3bda2e49b93c3.jpg";